import { dialogsTestIds } from "../../../utility/tests/testId/dialogs"

export const DIALOG_OPERATION_FEEDBACK_FORM_CONST = {
    tNamespace: "dialogs",
    tPaths: {
        defaultHeader: "feedback-form.header.default",
        successHeader: "feedback-form.header.success",
        errorHeader: "feedback-form.header.error",
        rate: "feedback-form.rate",
        defaultSuggestion: "feedback-form.suggestion.default",
        successSuggestion: "feedback-form.suggestion.success",
        errorSuggestion: "feedback-form.suggestion.error",
        feedback: "feedback-form.feedback",
        feedbackPlaceholder: "feedback-form.feedback-placeholder",
        retryButton: "feedback-form.retry-button",
        validation: "feedback-form.validation"
    },
    testIds: {
        closeButton: dialogsTestIds.feedbackFormCloseButton,
        submitButton: dialogsTestIds.feedbackFormSubmitButton,
        retryButton: dialogsTestIds.feedbackFormRetryButton,
        feedback: dialogsTestIds.feedbackFormFeedback,
        rating: dialogsTestIds.feedbackFormRating,
        heartIcon: dialogsTestIds.feedbackFormHeartIcon,
        robotSuccess: dialogsTestIds.feedbackFormRobotSuccess,
        robotDefault: dialogsTestIds.feedbackFormRobotDefault
    }
}
